import React from 'react';
import Id from "../../../../../../../../components/Operation/Id";
import Logo from "../../../../../../../../components/Operation/Logo";
import OperationStatus from "../../../../../../../../components/Operation/OperationStatus";
import { useOperation } from '../../../../../../../../contexts/OperationContext';
import styles from "../../style.module.scss";

const BannerOperation: React.FC = () => {
    const [operation] = useOperation(state => state.data?.operation);
    const [realStatus] = useOperation(state => state.realStatus);
    if (!operation || !realStatus)
        return null;
    const { operation_type, operation_code, event_type } = operation || {};

    return <div className={styles.banner}>
        <div className={styles.contentBanner}>
            <Logo
                type={operation_type}
                status={realStatus}
                dataAttribute={{ 'data-event-type': event_type }}
            />
            <Id operation={{ operation_code }} status={realStatus} />
            <OperationStatus status={realStatus} />
        </div>
    </div>;
};

export default BannerOperation;
